// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"354":"ddce7a5fe9145f6a","2863":"432a605ab52b7240","3185":"232c114717637b8a","4025":"432a605ab52b7240"}[chunkId] + ".css";
};